import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const AuthImage = ({ path, alt, className, onClick, testId }) => {
  const [src, setSrc] = useState("");
  useEffect(() => {
    let url = "";
    let alive = true;
    api.get(path, { responseType: "blob" })
      .then((r) => { if (alive) { url = URL.createObjectURL(r.data); setSrc(url); } })
      .catch(() => {});
    return () => { alive = false; if (url) URL.revokeObjectURL(url); };
  }, [path]);
  return src ? <img src={src} alt={alt} className={className} onClick={() => onClick?.(src)} data-testid={testId} />
    : <div className={`${className} img-loading`} />;
};
